import { NetworkService } from '../services'
import { BaseTransport } from '../transports'
import { RequestUserConfig } from '../common/types'
import EventSearchResultPageTransport, {
    CategoryTransport,
    EventSearchCategoriesQueryParamsTransport,
    EventSearchResultQueryParamsTransport,
    EventsSearchResultPageRequestParamsTransport,
    SearchResponseTransport,
} from '../transports/event/search-result-page-transport'
import EventLandingPageTransport, { EventLandingPageRequestParams } from '../transports/event/landing-page-transport'
import { EventDetailPageRequestParams, EventDetailPageTransport } from '../transports/event/detail-page-transport'
import EventDateTransport from '../transports/event/date-transport'
import RegionsGeolocationTransport from '../transports/event/regions-geolocation-transport'

class EventClient {
    public getEventLandingPage({
        user,
        params,
    }: {
        user: RequestUserConfig
        params: EventLandingPageRequestParams
    }): Promise<BaseTransport<EventLandingPageTransport>> {
        const headers = {
            'x-language': user.language,
            'x-domain': user.domain,
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            // url: '/v3/81619e1d-beea-4787-8988-7f307893b43e',
            url: '/api/events/v1/landing-page',
            headers,
            params,
        })
    }

    public getEventDetailPage({
        user,
        params,
        eventId,
    }: {
        user: RequestUserConfig
        params: EventDetailPageRequestParams
        eventId: string
    }): Promise<BaseTransport<EventDetailPageTransport>> {
        const headers = {
            'x-language': user.language,
            'x-domain': user.domain,
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            // url: '/v3/8fe59368-066f-4e2e-b01a-62bc70b7b841',
            url: `/api/events/v1/${eventId}/details-page`,
            headers,
            params,
        })
    }

    public getEventDates({
        user,
        eventId,
    }: {
        user: RequestUserConfig
        eventId: string
    }): Promise<BaseTransport<EventDateTransport[]>> {
        const headers = {
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            // url: '/v3/7f67d326-ab2f-4a25-a773-eeebda75eb48',
            url: `/api/events/v1/${eventId}/dates`,
            headers,
        })
    }

    public getEventsSearchResultPage({
        user,
        params,
    }: {
        user: RequestUserConfig
        params: EventsSearchResultPageRequestParamsTransport
    }): Promise<BaseTransport<EventSearchResultPageTransport>> {
        const headers = {
            'x-language': user.language,
            'x-domain': user.domain,
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            // url: '/v3/76ec7efc-7d14-47ff-a86f-36e77b2b9250',
            url: '/api/events/v1/search-result-page',
            headers,
            params,
        })
    }

    public getSearchEvents({
        user,
        params,
    }: {
        user: RequestUserConfig
        params: EventSearchResultQueryParamsTransport
    }): Promise<BaseTransport<SearchResponseTransport>> {
        const headers = {
            'x-language': user.language,
            'x-domain': user.domain,
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            // url: '/v3/9f9cba51-42aa-4986-ac39-c9dce328b188',
            url: '/api/events/v1/search-events',
            headers,
            params,
        })
    }

    public getRegionsGeolocation({
        user,
    }: {
        user: RequestUserConfig
    }): Promise<BaseTransport<RegionsGeolocationTransport>> {
        const headers = {
            'x-language': user.language,
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            // url: '/v3/d0185e10-541d-42de-be56-3f142179e776',
            url: '/api/events/v1/regions-geolocations',
            headers,
        })
    }

    public getFilteredCategories({
        user,
        params,
    }: {
        user: RequestUserConfig
        params: EventSearchCategoriesQueryParamsTransport
    }): Promise<BaseTransport<CategoryTransport[]>> {
        const headers = {
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            // url: '/v3/3830ed64-cbab-41c9-a5ca-48a19734c28c',
            url: '/api/events/v1/search-categories',
            headers,
            params,
        })
    }

    public getEventsCount({
        user,
        params,
    }: {
        user: RequestUserConfig
        params: EventSearchCategoriesQueryParamsTransport
    }): Promise<BaseTransport<number>> {
        const headers = {
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            url: '/api/events/v1/search-count',
            headers,
            params,
        })
    }
}

export default new EventClient()
